import * as actions from './actions';

const defaultGoogleOAuthState = {
  isSubmitting: false,
  submitError: '',
  submitWasSuccessful: false
}

const googleOAuthReducer = (state = defaultGoogleOAuthState, action) => {
  switch(action.type) {
    case actions.BEGIN_SUBMIT:
      return Object.assign({}, state, { isSubmitting: true })
    case actions.SUBMIT_SUCCESS:
      return Object.assign({}, state, { isSubmitting: false, submitWasSuccessful: true })
    case actions.SUBMIT_FAILURE:
      return Object.assign({}, state, { isSubmitting: false, submitError: action.errorMessage })
    default:
      return state
  }
}

export default googleOAuthReducer;
